import type * as React from "react";
import { Box, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import {
  selectSpouseInformation,
  selectUserPersonalInformation
} from "store/reducers/user/UserAccountSlice";
import { GENOMIC_LIFE_REFERRAL_INVITE_LINK_LABEL } from "constants/externalPathConstants";
import { COLORS } from "components/v3/Theme/colors";
import { planCardSx } from "./planInformationStyles";

const SpouseInviteCard: React.FC = () => {
  const userInformation = useSelector(selectUserPersonalInformation);
  const spouseAccessCode = useSelector(selectSpouseInformation)
    ?.spouseAccessCode;
  const isMemberActive = userInformation.isMemberActive !== false;

  if (!spouseAccessCode || !isMemberActive) {
    return null;
  }

  return (
    <Box data-testid="spouse-invite-card" sx={planCardSx}>
      <Box
      sx={{
        alignItems: "center",
        display: "flex",
        flexWrap: "wrap",
        gap: 1.5,
        mb: 2
      }}
    >
      <Typography
        variant="body_strong_black"
        sx={{
          color: COLORS.BLACK,
          fontSize: "1.125rem",
          fontWeight: 700,
        }}
      >
        Spouse plan
      </Typography>
      <Box
        sx={{
          backgroundColor: COLORS.ACCENT3_LIGHT,
          borderRadius: "999px",
          px: 1.75,
          py: 0.5
        }}
      >
        <Typography
          component="span"
          sx={{
            color: COLORS.ACCENT3_DARKER,
            fontSize: "0.8125rem",
            fontWeight: 600
          }}
        >
          Included
        </Typography>
      </Box>
      </Box>
      <Typography
        variant="body2"
        sx={{ color: COLORS.DARK_GRAY_2, lineHeight: 1.65, mb: 2 }}
      >
        Good news! Your spouse has been enrolled as part of your plan. Please
        share this access code with your spouse and have them go to{" "}
        {GENOMIC_LIFE_REFERRAL_INVITE_LINK_LABEL} to get started.
      </Typography>
      <Box sx={{backgroundColor: COLORS.PRIMARY_LIGHTEST, borderRadius: "12px", padding: "16px"}}>
      <Typography
        variant="body2"
        sx={{ color: COLORS.DARK_GRAY_2, fontWeight: 600, mb: 1 }}
      >
        Their invite code:
      </Typography>
      <Typography
        sx={{
          color: COLORS.ACCENT2,
          fontSize: "1.25rem",
          fontWeight: 700,
          letterSpacing: "0.02em",
          mb: 1
        }}
      >
        {spouseAccessCode}
      </Typography>
      <Typography
        variant="body2"
        sx={{
          color: COLORS.DARK_GRAY,
          fontStyle: "italic",
          lineHeight: 1.5
        }}
      >
        This code is only intended for your spouse. This code expires once its
        used.
      </Typography>
      </Box>
    </Box>
  );
};

export default SpouseInviteCard;
